"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var lastId = 0;
function _default() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'pv_id_';
  lastId++;
  return "".concat(prefix).concat(lastId);
}



//////////////////
// WEBPACK FOOTER
// ./~/primevue/utils/UniqueComponentId.js
// module id = 420
// module chunks = 7